import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent } from './header.component';
export class HeaderModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent],
    declarations: [HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HeaderModule_tsickle_Closure_declarations() {
/** @type {?} */
HeaderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
